module.exports = __webpack_public_path__ + "fdb9eadbb68ec83c6dab1c09a54714c8.jpg";